(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[86139],{

/***/ 25416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AffiliateOfferUrl; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/lib/shared/cookies.ts
var cookies = __webpack_require__(76309);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/api/index.ts + 19 modules
var api = __webpack_require__(21513);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
;// CONCATENATED MODULE: ./src/components/shared/affiliateOfferUrl/mobileIcon.tsx

const MobileIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        id: "Layer_2",
        viewBox: "0 0 16 22",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            id: "Layer_1-2",
            fill: "#fff",
            d: "M2 12.25V20 2zM2 22c-.55 0-1.02-.2-1.41-.59S0 20.55 0 20V2C0 1.45.2.98.59.59S1.45 0 2 0h10c.55 0 1.02.2 1.41.59S14 1.45 14 2v2h-2V2H2v18h10v-2h2v2c0 .55-.2 1.02-.59 1.41S12.55 22 12 22zm5.71-3.5c.19-.19.29-.43.29-.71s-.1-.52-.29-.71-.43-.29-.71-.29-.52.1-.71.29-.29.43-.29.71.1.52.29.71.43.29.71.29.52-.1.71-.29m3.62-4.65L9.88 12.4c.2-.18.35-.4.46-.64s.16-.5.16-.76-.05-.52-.16-.76-.26-.45-.46-.64l1.45-1.45c.38.38.68.82.88 1.31s.3 1 .3 1.54-.1 1.05-.3 1.54-.49.93-.88 1.31m2.45 2.45-1.4-1.4c.52-.52.92-1.11 1.2-1.78s.43-1.38.43-2.13-.14-1.46-.43-2.13-.68-1.26-1.2-1.78l1.4-1.4q1.08 1.05 1.65 2.43c.57 1.38.58 1.88.58 2.88s-.19 1.96-.58 2.88-.93 1.73-1.65 2.43"
        })
    });
/* harmony default export */ var mobileIcon = (MobileIcon);

// EXTERNAL MODULE: ./src/components/shared/affiliateOfferUrl/style.module.scss
var style_module = __webpack_require__(24027);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./src/components/shared/offerVertical/index.tsx
var offerVertical = __webpack_require__(71466);
;// CONCATENATED MODULE: ./src/components/shared/affiliateOfferUrl/index.tsx








function AffiliateOfferUrl({ className , children , customHref , offer , target , style , zone , template ="default"  }) {
    const { 0: listId , 1: setListId  } = (0,react.useState)(null);
    const { category , locale  } = (0,useDomainContext/* useDomainContext */.w)();
    const clickToCallLabel = (0,offerVertical/* getText */.Q)(category?.config?.clickToCallLabel, locale);
    (0,react.useEffect)(()=>{
        setListId((0,cookies/* getAffiliateListId */.Hf)());
    }, [
        cookies/* getAffiliateListId */.Hf
    ]);
    const queryParams = [];
    if (listId) {
        queryParams.push(`id=${listId}`);
    }
    if (offer?.category?.id) {
        queryParams.push(`categoryId=${offer.category.id.toString()}`);
    }
    if (zone) {
        queryParams.push(`zone=${zone}`);
    }
    let innerLinkContent = children;
    if (customHref) {
        if (template === "default") {
            innerLinkContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: children
            });
        } else {
            innerLinkContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (style_module_default()).clickToCallWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (style_module_default()).svgWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mobileIcon, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (style_module_default()).textWrapper,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (style_module_default()).clickToCall,
                                    children: clickToCallLabel || "Click to Call"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (style_module_default()).phoneNumberClick,
                                    children: children
                                })
                            ]
                        })
                    ]
                })
            });
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        style: style,
        target: target,
        className: className ?? "",
        rel: "noreferrer",
        href: customHref ?? `/offer/${offer?.slug ?? ""}?${queryParams.join("&")}`,
        onClick: ()=>{
            if (customHref) {
                void (0,api/* callEvent */.dr)({
                    event: "Call",
                    phoneNumber: customHref?.split("tel:")[1] ?? ""
                });
            }
        },
        children: innerLinkContent
    });
}


/***/ }),

/***/ 14203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24342);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2__);



const ButtonArrow = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["button-arrow"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().inner)
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ButtonArrow);


/***/ }),

/***/ 71466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ getText; },
/* harmony export */   "Z": function() { return /* binding */ OfferVertical; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_variables_businessphonepricesVariables_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81331);
/* harmony import */ var _styles_variables_businessphonepricesVariables_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_variables_businessphonepricesVariables_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75094);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76877);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _affiliateOfferUrl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25416);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88737);







const getText = (text, locale)=>{
    return text?.[locale] ?? text?.["en"] ?? "";
};
function OfferVertical({ offer , zone , displayLinkAndPhoneNumber , customStyle , template ="default"  }) {
    const phoneNumber = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__/* .getPhoneNumber */ .ly)(offer);
    const { domain , category , locale  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_4__/* .useDomainContext */ .w)();
    const callToActionTitle = getText(category?.config?.offerVerticalCallToActionTitle, locale);
    const callToActionSubTitle = getText(category?.config?.offerVerticalCallToActionSubTitle, locale);
    const buttonFallbackText = getText(category?.config?.offerVerticalButtonFallbackText, locale);
    const freeEvaluationNote = getText(category?.config?.offerVerticalFreeEvaluationNote, locale);
    const phoneNumberMessage = offer?.attributes.phoneNumberMessage ? offer?.attributes.phoneNumberMessage : offer?.hiddenAttributes.phoneNumberMessage ? offer?.hiddenAttributes.phoneNumberMessage : "";
    const outerSectionStyle = {
        "--buttonBackgroundColor": `${customStyle?.buttonBgColor ?? (_styles_variables_businessphonepricesVariables_module_scss__WEBPACK_IMPORTED_MODULE_5___default().autumnGlory)}`
    };
    const clickToCallBorder = typeof domain.config?.clickToCallBorder === "string" ? domain.config.clickToCallBorder : undefined;
    const clickToCallBtnBackground = typeof domain.config?.clickToCallBtnBackground === "string" ? domain.config.clickToCallBtnBackground : undefined;
    const clickToCallBtnForground = typeof domain.config?.clickToCallBtnForground === "string" ? domain.config.clickToCallBtnForground : undefined;
    const clickToCallBtnShadow = typeof domain.config?.clickToCallBtnShadow === "string" ? `rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, ${domain.config.clickToCallBtnShadow} 0px 10px 15px -3px, ${domain.config.clickToCallBtnShadow} 0px 4px 6px -4px ` : undefined;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().container)}  relative  mb-[30px] px-4 py-4   ${customStyle?.wrapperStyle ?? ""}`,
        style: outerSectionStyle,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-col flex-wrap items-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: `w-40 mb-4 flex justify-center ${customStyle?.fixedHeight ? "h-20" : ""}`,
                    style: {
                        borderColor: (_styles_variables_businessphonepricesVariables_module_scss__WEBPACK_IMPORTED_MODULE_5___default().offerBorderColor)
                    },
                    children: offer.logo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: offer.logo.fullPath,
                        alt: offer.title
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-full",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        style: {
                                            fontSize: "24px",
                                            fontWeight: "700",
                                            lineHeight: 1.2
                                        },
                                        dangerouslySetInnerHTML: {
                                            __html: phoneNumberMessage || callToActionTitle || "Call Now & Discuss Options!"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().secondTitle),
                                    children: callToActionSubTitle || "Review offers and coverage eligibility instantly."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "order-3 flex flex-col mt-2 w-auto",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_affiliateOfferUrl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    zone: zone,
                                    template: template,
                                    className: `${!displayLinkAndPhoneNumber ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().link) : ""} ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().linkPageBuilderStyle)} ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().btnStyle)} flex justify-center rounded-5 text-center px-[10px] py-[10px] text-[15px]`,
                                    offer: offer,
                                    customHref: phoneNumber ? `tel:${phoneNumber ?? ""}` : undefined,
                                    target: "_blank",
                                    style: {
                                        borderRadius: "12px",
                                        border: clickToCallBorder,
                                        background: clickToCallBtnBackground,
                                        color: clickToCallBtnForground,
                                        boxShadow: clickToCallBtnShadow
                                    },
                                    children: (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__/* .formatPhoneNumber */ .un)(phoneNumber) || buttonFallbackText || "Let's Go"
                                }),
                                displayLinkAndPhoneNumber && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_affiliateOfferUrl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    zone: zone,
                                    className: `text-left lg:text-center py-3 rounded-lg ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().letGoStyle)}`,
                                    offer: offer,
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: buttonFallbackText || "Let's Go"
                                    })
                                })
                            ]
                        }),
                        (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__/* .formatPhoneNumber */ .un)(phoneNumber) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            style: {
                                fontSize: "12px",
                                color: "#666",
                                textAlign: "center",
                                marginTop: "15px"
                            },
                            children: freeEvaluationNote || "Free Evaluation • No Obligation"
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 76798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CheckIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function CheckIcon({ className , fill  }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        x: "0",
        y: "0",
        enableBackground: "new 0 0 32 26",
        version: "1.1",
        viewBox: "0 0 32 26",
        xmlSpace: "preserve",
        className: className ?? "",
        fill: fill,
        style: {
            fill: fill
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M27.1 0L25 2.2 10.7 17.4l-4.3-4.3L4.2 11 0 15.2l2.1 2.1 6.5 6.5 2.2 2.2 2.1-2.2L29.4 6.3l2.1-2.2L27.1 0z"
        })
    });
}


/***/ }),

/***/ 39717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Chevron; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Chevron({ className , fill  }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "8",
        height: "12",
        viewBox: "0 0 8 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.4 1.4L6 0L0 6L6 12L7.4 10.6L2.8 6L7.4 1.4Z",
            fill: fill ?? "black"
        })
    });
}


/***/ }),

/***/ 89894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ StarIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function StarIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "517",
        height: "493",
        fill: "none",
        viewBox: "0 0 517 493",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            d: "M257.542.014a11.2 11.2 0 00-10.105 7.719l-56.223 168.68H11.164a11.2 11.2 0 00-6.613 20.21l146.25 106.94-56.223 174.56v.004a11.197 11.197 0 004.086 12.535 11.203 11.203 0 0013.184-.039l146.25-106.94 146.25 106.94a11.203 11.203 0 0013.184.039 11.196 11.196 0 004.086-12.535l-56.223-174.56 146.25-106.94v-.004a11.2 11.2 0 00-6.613-20.21h-180.05L268.759 7.733a11.2 11.2 0 00-11.207-7.72h-.01z",
            clipRule: "evenodd"
        })
    });
}


/***/ }),

/***/ 86139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Offer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/svg/checkIcon.tsx
var checkIcon = __webpack_require__(76798);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/lib/sharedUtils.ts
var sharedUtils = __webpack_require__(75094);
// EXTERNAL MODULE: ./src/components/shared/affiliateOfferUrl/index.tsx + 1 modules
var affiliateOfferUrl = __webpack_require__(25416);
// EXTERNAL MODULE: ./src/lib/shared/config.ts
var config = __webpack_require__(98218);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
// EXTERNAL MODULE: ./src/page-builder/components/affiliateOfferList/style.module.scss
var style_module = __webpack_require__(72456);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./src/components/svg/starIcon.tsx
var starIcon = __webpack_require__(89894);
;// CONCATENATED MODULE: ./src/components/svg/badgeIcon.tsx


function BadgeIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.0281 7.51917L9.91185 12.4927C9.92175 12.5512 9.91354 12.6114 9.8883 12.6652C9.86307 12.719 9.82202 12.7637 9.77065 12.7935C9.71928 12.8234 9.66003 12.8368 9.60082 12.832C9.54162 12.8272 9.48529 12.8045 9.43935 12.7668L7.35102 11.1994C7.25021 11.1241 7.12774 11.0834 7.0019 11.0834C6.87605 11.0834 6.75359 11.1241 6.65277 11.1994L4.56094 12.7662C4.51504 12.8038 4.45877 12.8265 4.39964 12.8313C4.34051 12.8361 4.28133 12.8227 4.22999 12.793C4.17865 12.7633 4.1376 12.7186 4.11231 12.6649C4.08702 12.6113 4.07869 12.5512 4.08844 12.4927L4.9716 7.51917",
                stroke: "currentColor",
                strokeWidth: "1.16667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7 8.16663C8.933 8.16663 10.5 6.59962 10.5 4.66663C10.5 2.73363 8.933 1.16663 7 1.16663C5.067 1.16663 3.5 2.73363 3.5 4.66663C3.5 6.59962 5.067 8.16663 7 8.16663Z",
                stroke: "currentColor",
                strokeWidth: "1.16667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}
/* harmony default export */ var badgeIcon = (BadgeIcon);

// EXTERNAL MODULE: ./src/components/svg/chevron.tsx
var chevron = __webpack_require__(39717);
;// CONCATENATED MODULE: ./src/components/svg/greenCheckCircle.tsx


function GreenCheckCircle() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "20",
                height: "20",
                rx: "10",
                fill: "#2EA957",
                fillOpacity: "0.15"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.6668 6.5L8.25016 12.9167L5.3335 10",
                stroke: "#2EA957",
                strokeWidth: "1.16667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}
/* harmony default export */ var greenCheckCircle = (GreenCheckCircle);

;// CONCATENATED MODULE: ./src/components/svg/blueRightIcon.tsx


function BlueRightIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "10",
        height: "10",
        viewBox: "0 0 10 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3.00056 1.00594C3.27334 0.694337 3.74748 0.662901 4.05916 0.935623L8.05916 4.43562C8.22183 4.57803 8.31502 4.78386 8.31502 5.00008C8.31502 5.21629 8.22183 5.42212 8.05916 5.56453L4.05916 9.06453C3.74748 9.33725 3.27334 9.30582 3.00056 8.99422C2.72784 8.68254 2.75928 8.2084 3.07088 7.93562L6.42537 5.00008L3.07088 2.06453C2.75928 1.79175 2.72784 1.31762 3.00056 1.00594Z",
            fill: "#0076F7"
        })
    });
}
/* harmony default export */ var blueRightIcon = (BlueRightIcon);

;// CONCATENATED MODULE: ./src/components/svg/rateStarIcon.tsx


function RateStarIcon({ empty =false  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "29",
        height: "28",
        viewBox: "0 0 29 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M13.9261 2.67754C13.9791 2.57424 14.0609 2.48729 14.1623 2.4265C14.2637 2.36571 14.3807 2.3335 14.5001 2.3335C14.6194 2.3335 14.7364 2.36571 14.8378 2.4265C14.9393 2.48729 15.0211 2.57424 15.074 2.67754L17.8653 8.13637C18.0491 8.49567 18.3206 8.80651 18.6563 9.04223C18.992 9.27795 19.3819 9.4315 19.7926 9.48971L26.0348 10.3717C26.1531 10.3883 26.2642 10.4364 26.3556 10.5108C26.447 10.5851 26.515 10.6827 26.552 10.7924C26.589 10.9021 26.5934 11.0197 26.5648 11.1317C26.5361 11.2437 26.4756 11.3458 26.3901 11.4264L21.8757 15.6707C21.578 15.9508 21.3553 16.2966 21.2267 16.6783C21.098 17.0599 21.0674 17.4661 21.1374 17.8617L22.2032 23.8584C22.2241 23.9725 22.2113 24.09 22.1663 24.1975C22.1214 24.305 22.046 24.3981 21.9489 24.4662C21.8518 24.5343 21.7367 24.5747 21.617 24.5828C21.4972 24.5908 21.3775 24.5662 21.2716 24.5117L15.6915 21.679C15.3238 21.4926 14.9147 21.3952 14.4995 21.3952C14.0842 21.3952 13.6751 21.4926 13.3074 21.679L7.72856 24.5117C7.62263 24.5659 7.50308 24.5902 7.38352 24.582C7.26396 24.5738 7.14919 24.5334 7.05225 24.4653C6.95531 24.3972 6.88011 24.3043 6.83519 24.197C6.79026 24.0897 6.77743 23.9724 6.79814 23.8584L7.86268 17.8629C7.933 17.4671 7.90254 17.0607 7.77392 16.6788C7.6453 16.2968 7.42238 15.9509 7.12439 15.6707L2.61006 11.4275C2.52378 11.3471 2.46263 11.2448 2.4336 11.1325C2.40456 11.0201 2.4088 10.9021 2.44582 10.7919C2.48285 10.6818 2.55117 10.5839 2.64302 10.5094C2.73486 10.4349 2.84653 10.3868 2.96531 10.3705L9.20635 9.48971C9.61749 9.43195 10.0079 9.27861 10.3441 9.04286C10.6803 8.80711 10.952 8.49602 11.1361 8.13637L13.9261 2.67754Z",
            fill: empty ? "#ECF3F8" : "#FFB60B",
            stroke: empty ? "#ECF3F8" : "#FFB60B",
            strokeWidth: "1.33333",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
}
/* harmony default export */ var rateStarIcon = (RateStarIcon);

;// CONCATENATED MODULE: ./src/components/shared/starRating/index.tsx



const StarRating = ({ rating , max =5  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex items-center",
        children: Array.from({
            length: max
        }, (_, i)=>{
            const fill = Math.max(0, Math.min(1, rating - i));
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative text-2xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(rateStarIcon, {
                        empty: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "absolute left-0 top-0 overflow-hidden text-yellow-400",
                        style: {
                            width: `${fill * 100}%`
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(rateStarIcon, {})
                    })
                ]
            }, i);
        })
    });
/* harmony default export */ var shared_starRating = (StarRating);

;// CONCATENATED MODULE: ./src/page-builder/components/affiliateOfferList/OfferRating.tsx




function OfferRating({ rating , starRatingScore =5 , hideText =false , starRating =false , starsCount =5  }) {
    const resolveWordedRating = (rating)=>{
        if (rating >= 9.5) {
            return "Exceptional";
        }
        if (rating >= 8) {
            return "Excellent";
        }
        if (rating >= 7) {
            return "Great";
        }
        return "Good";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: rating ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (style_module_default()).rating,
            children: [
                !hideText && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (style_module_default()).worded,
                    children: resolveWordedRating(rating)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (style_module_default()).numbered,
                    children: rating
                }),
                starRating && /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_starRating, {
                    rating: starRatingScore,
                    max: starsCount
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    });
}

// EXTERNAL MODULE: ./src/components/shared/buttonArrow/index.tsx
var buttonArrow = __webpack_require__(14203);
;// CONCATENATED MODULE: ./src/page-builder/components/affiliateOfferList/OfferCTA.tsx








function OfferCTA({ offer , clicked , onClick , featuredOfferMessage , isFeatured , isExternal , slug , buttonText , actionButtonText , revenue , phoneNumber , useActionButton , onlyButtonAndLinksClickable , zone , useHiddenAttributes , listItemExclusiveOffer , listItemReviewLink , textUnderButton , ratingBlock , category , region , city  }) {
    const displayLinkAndPhoneNumber = offer ? (0,sharedUtils/* doesOfferHaveALink */.hn)(offer) : false;
    const overlayClass = `before:absolute before:w-full before:h-full before:left-0 before:top-0`;
    const showExclusiveOffer = useHiddenAttributes && listItemExclusiveOffer;
    const showReviewButton = useHiddenAttributes && listItemReviewLink && !useActionButton;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `${(style_module_default()).cta} ${clicked ? (style_module_default()).clicked : ""}`,
        style: {
            textAlign: "center"
        },
        children: [
            ratingBlock,
            showExclusiveOffer && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (style_module_default()).exclusiveOffer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (style_module_default()).exclusiveOfferTitle,
                        children: "EXCLUSIVE OFFER"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (style_module_default()).exclusiveOfferDescription,
                        children: listItemExclusiveOffer
                    })
                ]
            }),
            revenue && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "mb-1 block",
                children: [
                    "$",
                    revenue
                ]
            }),
            isExternal ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                target: "_blank",
                onClick: onClick,
                href: useHiddenAttributes ? "#" : `/offer/${slug ?? ""}&isExternalOffer=true`,
                rel: "noreferrer",
                className: `${(style_module_default()).button} ${!onlyButtonAndLinksClickable ? overlayClass : ""}`,
                children: !clicked ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (style_module_default()).main,
                    children: [
                        (0,sharedUtils/* replacePlaceholders */.wT)(buttonText ?? "", {
                            category: category ?? "",
                            region: region ?? "",
                            city: city ?? ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(buttonArrow/* default */.Z, {})
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (style_module_default()).check,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(checkIcon/* default */.Z, {})
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: showReviewButton ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    href: `${listItemReviewLink}`,
                    target: "_self",
                    rel: "noreferrer",
                    className: `text-center py-3 rounded-lg lg:px-6 ${!displayLinkAndPhoneNumber && !onlyButtonAndLinksClickable ? `${overlayClass}` : ""} ${(style_module_default()).button}`,
                    children: [
                        buttonText,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(buttonArrow/* default */.Z, {})
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(affiliateOfferUrl/* default */.Z, {
                            zone: zone ?? config/* affiliateOfferZones.PAGE_BUILDER */.ZR.PAGE_BUILDER,
                            target: !phoneNumber || useActionButton ? "_blank" : undefined,
                            className: `text-center py-3 rounded-lg lg:px-6 ${!displayLinkAndPhoneNumber && !onlyButtonAndLinksClickable ? `${overlayClass}` : ""} ${(style_module_default()).button}`,
                            offer: offer,
                            customHref: phoneNumber && !useActionButton ? `tel:${phoneNumber ?? ""}` : undefined,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    useActionButton && actionButtonText ? actionButtonText : (0,sharedUtils/* formatPhoneNumber */.un)(phoneNumber) ?? buttonText,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(buttonArrow/* default */.Z, {})
                                ]
                            })
                        }),
                        displayLinkAndPhoneNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)(affiliateOfferUrl/* default */.Z, {
                            zone: zone ?? config/* affiliateOfferZones.PAGE_BUILDER */.ZR.PAGE_BUILDER,
                            className: `text-left lg:text-center py-3 rounded-lg ${(style_module_default()).link}`,
                            offer: offer,
                            target: "_blank",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "View Deals"
                            })
                        })
                    ]
                })
            }),
            textUnderButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (style_module_default()).txtUnderBtn,
                children: textUnderButton
            }),
            isFeatured && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (style_module_default())["featured-offer-message"],
                children: featuredOfferMessage
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/page-builder/components/affiliateOfferList/Offer.tsx















function Offer({ offer , index , logoUrl , buttonText , title , bulletedDescription , revenue , slug , isExternal , featuredOfferMessage , featuredOfferMessagePosition ="cta" , ratingPosition ="cta" , zone , showIndex =false , showRating =false , showSummary =false , showSeparator =false , useHiddenAttributes =false , textUnderButton , hiddenAttributes ={} , hideRatingText =false , starRating =false , onlyButtonAndLinksClickable =false , maxOffersWithAction , actionButtonText , hideDescription =false  }) {
    const { isBot , visitDetails , category  } = (0,useDomainContext/* useDomainContext */.w)();
    const { 0: clicked , 1: setClicked  } = (0,react.useState)(false);
    const { 0: summaryExpanded , 1: setSummaryExpanded  } = (0,react.useState)(false);
    const { listItemTitle , listItemDescription , listItemFeatures , listItemTip1 , listItemTip2 , listItemExclusiveOffer , listItemReviewLink , listItemRating ,  } = hiddenAttributes;
    const featuredMessage = (0,react.useMemo)(()=>{
        if (!featuredOfferMessage) return undefined;
        return (0,sharedUtils/* replacePlaceholders */.wT)(featuredOfferMessage, {
            category: category?.name,
            region: visitDetails?.region,
            city: visitDetails?.city
        });
    }, [
        featuredOfferMessage,
        category?.name,
        visitDetails?.region,
        visitDetails?.city, 
    ]);
    const featuresList = (0,react.useMemo)(()=>{
        if (useHiddenAttributes && listItemFeatures?.length) {
            return listItemFeatures.replace(/^\[|\]$/g, "").split(",").map((item)=>item.trim().replace(/^"|"$/g, ""));
        }
        return bulletedDescription;
    }, [
        useHiddenAttributes,
        listItemFeatures,
        bulletedDescription
    ]);
    const rating = (0,react.useMemo)(()=>{
        if (useHiddenAttributes && listItemRating) {
            return Number(listItemRating);
        }
        if (offer?.score) {
            return Math.min(Number(offer.score) * 2, 10);
        }
        return 5;
    }, [
        useHiddenAttributes,
        listItemRating,
        offer?.score
    ]);
    const starRatingScore = (0,react.useMemo)(()=>{
        if (useHiddenAttributes && listItemRating) {
            return Number(listItemRating) / 2;
        }
        return Number(offer?.score) || 5;
    }, [
        useHiddenAttributes,
        listItemRating,
        offer?.score
    ]);
    if (isBot) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    const isFeatured = index === 0 && Boolean(featuredMessage);
    const useActionBtn = Boolean(actionButtonText) && index < (maxOffersWithAction ?? 0);
    const phoneNumber = (0,sharedUtils/* getPhoneNumber */.ly)(offer);
    const ratingBlock = showRating ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (style_module_default()).mobileRatingVariant,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferRating, {
                    rating: rating,
                    starRatingScore: starRatingScore,
                    starsCount: 1,
                    starRating: true,
                    hideText: hideRatingText
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (style_module_default()).desktopRatingVariant,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferRating, {
                    rating: rating,
                    starRatingScore: starRatingScore,
                    starRating: starRating,
                    hideText: hideRatingText
                })
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    const handleClick = ()=>{
        setClicked(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `${(style_module_default())["listing-block"]} ${isFeatured && (style_module_default()).featured || ""} ${isFeatured && featuredOfferMessagePosition === "banner" ? (style_module_default()).listingBlockOverflow : ""} ${index === 0 ? (style_module_default()).firstOfferBlock : ""}`,
        children: [
            isFeatured && featuredOfferMessagePosition === "banner" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (style_module_default()).bannerFeaturedOfferMessage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: featuredMessage
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            (isFeatured && featuredOfferMessagePosition === "top" || showIndex) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (style_module_default())["offer-index"],
                children: [
                    showIndex && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (style_module_default()).index,
                        children: String(index + 1).padStart(2, "0")
                    }),
                    isFeatured && featuredOfferMessagePosition === "top" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (style_module_default())["featured-offer-message-top"] + ` ${!showIndex ? "ml-10 mt-2" : ""}`,
                        children: featuredMessage
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                ]
            }),
            isFeatured && !showIndex && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (style_module_default()).order,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(starIcon/* default */.Z, {})
            }),
            useHiddenAttributes && listItemTip1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (style_module_default()).mobileListItemTip1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(badgeIcon, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            " ",
                            listItemTip1
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (style_module_default()).logo,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(affiliateOfferUrl/* default */.Z, {
                        zone: zone ?? config/* affiliateOfferZones.PAGE_BUILDER */.ZR.PAGE_BUILDER,
                        target: !phoneNumber ? "_blank" : undefined,
                        offer: offer,
                        customHref: phoneNumber ? `tel:${phoneNumber ?? ""}` : undefined,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: logoUrl,
                            alt: "logo",
                            loading: "lazy"
                        })
                    }),
                    ratingBlock
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: `${(style_module_default()).content} ${ratingPosition === "middle" || ratingPosition === "middleWithSeparator" ? (style_module_default()).contentWithRatingMiddle : ""} ${showSeparator ? (style_module_default()).contentShowSeparator : ""}`,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (style_module_default()).offerHeaderTips,
                        children: [
                            useHiddenAttributes && listItemTip1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (style_module_default()).listItemTip1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(badgeIcon, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            " ",
                                            listItemTip1
                                        ]
                                    })
                                ]
                            }),
                            useHiddenAttributes && listItemTip2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (style_module_default()).listItemTip2,
                                children: listItemTip2
                            })
                        ]
                    }),
                    useHiddenAttributes && listItemTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (style_module_default()).propsTitle,
                        children: listItemTitle
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (style_module_default()).title,
                        dangerouslySetInnerHTML: {
                            __html: title ?? ""
                        }
                    }),
                    useHiddenAttributes && listItemDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (style_module_default()).propsDescription,
                        children: listItemDescription
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (style_module_default()).features,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            children: featuresList?.slice(0, 5)?.map((feature, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        useHiddenAttributes ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "children:h-4 children:w-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(greenCheckCircle, {})
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "children:h-3 children:w-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(checkIcon/* default */.Z, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "ml-2",
                                            dangerouslySetInnerHTML: {
                                                __html: feature
                                            }
                                        })
                                    ]
                                }, idx))
                        })
                    }),
                    useHiddenAttributes && listItemReviewLink && useActionBtn && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: `${listItemReviewLink}`,
                        target: "_self",
                        rel: "noreferrer",
                        className: (style_module_default()).reviewLink,
                        children: [
                            "Read Review ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(blueRightIcon, {})
                        ]
                    })
                ]
            }),
            ratingPosition === "middle" || ratingPosition === "middleWithSeparator" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `${(style_module_default()).ratingMiddle} ${ratingPosition === "middleWithSeparator" ? (style_module_default()).middleWithSeparator : ""}`,
                children: ratingBlock
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferCTA, {
                offer: offer,
                isFeatured: isFeatured,
                featuredOfferMessage: featuredOfferMessagePosition == "cta" ? featuredMessage : undefined,
                clicked: clicked,
                onClick: handleClick,
                isExternal: isExternal,
                slug: slug,
                ratingBlock: ratingPosition === "cta" ? ratingBlock : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                revenue: revenue,
                phoneNumber: phoneNumber,
                buttonText: buttonText,
                actionButtonText: actionButtonText,
                useActionButton: useActionBtn,
                onlyButtonAndLinksClickable: onlyButtonAndLinksClickable,
                zone: zone,
                useHiddenAttributes: useHiddenAttributes,
                listItemExclusiveOffer: listItemExclusiveOffer,
                listItemReviewLink: listItemReviewLink,
                textUnderButton: textUnderButton,
                category: category?.name,
                city: visitDetails?.city,
                region: visitDetails?.region
            }),
            showSummary && offer?.previewDescription && !hideDescription && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (style_module_default())["summary-container"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        onClick: ()=>{
                            setSummaryExpanded((prev)=>!prev);
                        },
                        className: (style_module_default())["summary-toggle"],
                        children: [
                            summaryExpanded ? "Hide Summary" : "Show Summary",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron/* default */.Z, {
                                className: `${summaryExpanded ? (style_module_default())["chevron-up"] : (style_module_default())["chevron-down"]}`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: `${(style_module_default()).summary} ${summaryExpanded ? (style_module_default()).expanded : ""}`,
                        dangerouslySetInnerHTML: {
                            __html: offer.previewDescription
                        }
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 24027:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"clickToCallWrapper":"style_clickToCallWrapper__VwAdQ","textWrapper":"style_textWrapper__4UGtd","svgWrapper":"style_svgWrapper__hIySB","clickToCall":"style_clickToCall__9Mqb6","phoneNumberClick":"style_phoneNumberClick__xFVNS"};

/***/ }),

/***/ 24342:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button-arrow":"styles_button-arrow__FF6j0","inner":"styles_inner__Ybwhd","expand":"styles_expand__Cx9pe"};

/***/ }),

/***/ 76877:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__wOf18","title":"style_title__cWvij","linkPageBuilderStyle":"style_linkPageBuilderStyle__CqdI2","letGoStyle":"style_letGoStyle__5KJJo","link":"style_link__LGb3m","secondTitle":"style_secondTitle__6rLsc","btnStyle":"style_btnStyle__6X7g_"};

/***/ }),

/***/ 81331:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"goGoGreen":"#008a7b","green":"#5bc1a4","bankVault":"#747474","autumnGlory":"#3ea636","offerBorderColor":"#e4e7eb"};

/***/ })

}]);